import { BodyText, Tooltip } from '@block-explorer/ui';
import { FlexColumn, FlexRow } from '@make-software/cspr-design';
import React from 'react';
import { SHORTENED_ENTRY_TYPE_LENGTH, truncateName } from '../utils';
import { Deploy } from '@block-explorer/entities';
import { ContractIdentifier } from '../../contract-identifier/contract-identifier';
import { isWASMProxyTransaction } from '../../../utils/contract.tsx';
import { WasmProxyBadge } from '../wasm-proxy-badge.tsx';
import styled from 'styled-components';

const StyledBodyText = styled(BodyText)(() => ({
  display: 'inline-flex',
  alignItems: 'center',
  height: 13,
  lineHeight: '13px',
}));

export const DefaultActionMessage = ({
  deploy,
  hideContractIdentifier = false,
}: {
  deploy: Deploy;
  hideContractIdentifier?: boolean;
}) => {
  const contractEntryPointName = deploy.entryPoint?.name || '';

  return (
    <FlexColumn>
      <FlexRow align={'baseline'} itemsSpacing={4}>
        {isWASMProxyTransaction(deploy.executionTypeId) && <WasmProxyBadge />}
        <FlexRow itemsSpacing={6} align={'baseline'}>
          <Tooltip tooltipContent={contractEntryPointName}>
            <BodyText monotype size={3} wordBreak noWrap>
              {truncateName(
                contractEntryPointName,
                SHORTENED_ENTRY_TYPE_LENGTH
              )}
            </BodyText>
          </Tooltip>
        </FlexRow>
      </FlexRow>
      {!hideContractIdentifier && (
        <FlexRow itemsSpacing={4} align={'center'}>
          <StyledBodyText variation={'darkGray'} size={3}>
            with
          </StyledBodyText>
          <ContractIdentifier
            hash={deploy.contractPackage.contract_package_hash}
            contractPackage={deploy.contractPackage}
          />
        </FlexRow>
      )}
    </FlexColumn>
  );
};
